<template>
  <div class="layout-product-promos">
    <div v-if="sale>0" class="sale xxs-title">Sale -{{ sale }}%</div>
    <div v-if="newprop"  class="sale xxs-title">{{ this.$store.state.langs.NEW }}</div>
    <div v-if="instock"  class="sale xxs-title">{{ this.$store.state.langs.STOCK }}</div>
    <div v-if="special" class="sale xxs-title">{{ this.$store.state.langs.SPECIAL_PROMO }}</div>
    <div v-if="delivery" class="delivery">
      <img src="@/assets/icons/delivery.svg" alt="delivery" />
      <div class="xs-title">{{ this.$store.state.langs.DELYVERY }}: {{ delivery }}</div>
    </div>

    <!--
    <div class="stars">
      <div v-for="star in 5" :key="star" :class="[{ active: Number(stars) >= star }]" class="star">
        <img src="@/assets/icons/star.svg" alt="" />
      </div>
    </div>
    -->
  </div>
</template>

<script>
export default {
  props: {
    newprop: {
          type: Boolean,
          default() {
              return false
          }
      },
    special: {
          type: Boolean,
          default() {
              return false
          }
      },
    instock: {
          type: Boolean,
          default() {
              return false
          }
      },
    stars: {
      type: String,
      default() {
        return ''
      }
    },
    sale: {
      type: Number,
      default() {
        return 0
      }
    },
    delivery: {
      type: String,
      default() {
        return ''
      }
    },
    pickup: {
      type: String,
      default() {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-product-promos {
  display: flex;
  align-items: center;
  margin: 2em 0;
  margin-left: 9em;
  &.left {
    margin-left: 0;
  }
  & > * {
    display: flex;
    align-items: center;
    &:not(:last-child) {
      margin-right: 2em;
    }
    img {
      margin-right: 0.3em;
    }
  }
}
.sale {
  background: var(--red);
  color: #fff;
  padding: 0.4em 0.5em;
}
.star {
  opacity: 0.2;
  &.active {
    opacity: 1;
  }
}
.delivery{
  white-space: nowrap;
}
@media screen and (max-width: 767px) {
  .layout-product-promos {
    margin-left: 0;
    flex-flow: wrap;
    & > * {
      margin: 0.2em 0;
      &:not(:last-child) {
        margin-right: 1em;
      }
    }
  }
}
</style>
